import Spinner from '@carvana/ds-spinner';
import heliosBreakpoints from '@carvana/merch-tailwind/breakpoints';
import cx from 'classnames';
import { memo, useState } from 'react';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import optimizeImage, { Options } from '~/utilities/optimizeImage';

const IMAGE_CONFIG: Options = {
  blur: 10,
  format: 'auto',
  quality: 80
};

function LoadingImage({ isVisible }: { isVisible: boolean }) {
  const {
    stockImageData: { jellyBeanDesktopUrl = '' } = {},
    vexVdpImageData: { heroes: { hero = '' } = {} } = {}
  } = useGetVehicleDetails();
  const [loadingImageFailed, setLoadingImageFailed] = useState(false);

  const imgSrc = loadingImageFailed ? jellyBeanDesktopUrl : hero;

  return (
    <div
      className={cx(
        'pointer-events-none absolute inset-0 z-3 bg-background-weak transition-opacity duration-300',
        isVisible ? 'opacity-100' : 'opacity-0'
      )}
    >
      {!loadingImageFailed && (
        <div className="absolute inset-0 z-20 flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      )}
      {imgSrc && (
        <picture>
          <source
            media={`(min-width: ${heliosBreakpoints.sm}px)`}
            srcSet={optimizeImage(imgSrc, {
              ...IMAGE_CONFIG,
              width: heliosBreakpoints.md
            })}
          />
          <img
            alt="vehicle image"
            decoding="async"
            draggable="false"
            fetchPriority="high"
            loading="eager"
            onError={() => {
              setLoadingImageFailed(true);
            }}
            src={optimizeImage(imgSrc, {
              ...IMAGE_CONFIG,
              width: heliosBreakpoints.sm
            })}
          />
        </picture>
      )}
    </div>
  );
}

export default memo(LoadingImage);
